import { useSubscribeToBrandMutation, useUnsubscribeFromBrandMutation } from './gql/graphql.v4.generated';

interface Payload {
  brandId: number,
  onSuccess?: () => void,
  onError?: () => void,
}

export const useBrandSubscription = () => {
  const [subscribeToBrand, {
    loading: subscribeLoading,
  }] = useSubscribeToBrandMutation({
    context: { v4: true },
    update: (cache, mutationData, options) => {
      if (!mutationData?.data?.subscribeToBrand?.errors) {
        cache.modify({
          id: `Brand:${options.variables?.brandId}`,
          fields: {
            isViewerSubscribed: () => true,
          },
        });
        cache.modify({
          id: `BrandType:${options.variables?.brandId}`,
          fields: {
            isViewerSubscribed: () => true,
          },
        });
      }
    },
  });
  const [unsubscribeFromBrand, {
    loading: unSubscribeLoading,
  }] = useUnsubscribeFromBrandMutation({
    context: { v4: true },
    update: (cache, mutationData, options) => {
      if (!mutationData?.data?.unsubscribeFromBrand?.errors) {
        cache.modify({
          id: `Brand:${options.variables?.brandId}`,
          fields: {
            isViewerSubscribed: () => false,
          },
        });
        cache.modify({
          id: `BrandType:${options.variables?.brandId}`,
          fields: {
            isViewerSubscribed: () => false,
          },
        });
      }
    },
  });

  const handleSubscribe = ({
    brandId,
    onSuccess,
    onError,
  }: Payload) => {
    subscribeToBrand({
      variables: {
        brandId,
      },
    }).then(({ data }) => {
      if (data?.subscribeToBrand.errors?.length && onError) {
        onError();
      } else if (onSuccess) {
        onSuccess();
      }
    }).catch(() => {
      if (onError) {
        onError();
      }
    });
  };

  const handleUnsubscribe = ({
    brandId,
    onSuccess,
    onError,
  }: Payload) => {
    unsubscribeFromBrand({
      variables: {
        brandId,
      },
    }).then(({ data }) => {
      if (data?.unsubscribeFromBrand.errors?.length && onError) {
        onError();
      } else if (onSuccess) {
        onSuccess();
      }
    }).catch(() => {
      if (onError) {
        onError();
      }
    });
  };

  return {
    loading: subscribeLoading || unSubscribeLoading,
    handleSubscribe,
    handleUnsubscribe,
  };
};
